<template>
    <div class="backpanel-view view" :class="{ incomplete: !state.backpanelStructure }">
        <instructions :titleKey="resourceKeys.titleKey" :property="resourceKeys.helpContent" />

        <backpanel-drawing />

        <div class="wrapper">
            <div class="section-content">
                <div class="section-main col-8">
                    <h2 class="h2" v-html="ui.t(resourceKeys.structure)"></h2>

                    <option-list v-model="state.backpanelStructure"
                        :optionList="ui.backpanelStructures"
                        :withImages="true"
                        classes="big"
                        :itemClasses="[ 'col-6', 'wide-image' ]"
                        @blur="ui.clearFocusedField()"
                        @focus="ui.focusedFieldName = 'backpanelStructure'" />
                </div>

                <div class="col-4 section-side" v-if="ui.backpanelStructure">
                    <h2 class="h2" v-html="ui.t(resourceKeys.dimensionsTitle)"></h2>

                    <number-input v-model="ui.backpanelLength"
                        :resourceKey="resourceKeys.length"
                        @blur="ui.clearFocusedField()"
                        @focus="ui.focusedFieldName = 'backpanelLength'"
                        :step="ui.backpanelStructure.step"
                        :min="ui.backpanelStructure.minLength"
                        :max="ui.backpanelStructure.maxLength" />

                    <number-input v-model="ui.backpanelHeight"
                        :resourceKey="resourceKeys.height"
                        @blur="ui.clearFocusedField()"
                        @focus="ui.focusedFieldName = 'backpanelHeight'"
                        :step="ui.backpanelStructure.step"
                        :min="ui.backpanelStructure.minHeight"
                        :max="ui.backpanelStructure.maxHeight" />
                </div>
            </div>
        </div>

        <div class="navigation">
            <div class="wrapper">
                <a href="" @click.prevent="" class="disabled" v-html="ui.t('previous')"></a>
                <router-link to="/backpanel-material" @click.native="moveNext" :class="{ next: true, disabled: !ui.backpanelSelectionsComplete }">
                    <span class="input-tip" v-if="moveNextPrevented" v-html="ui.t('selectionsIncomplete')"></span>
                    <span v-html="ui.t('next')"></span>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script async setup lang="ts">
import { ref, type Ref } from "vue";
import { useState, useUI } from "../store";
import { useRoute } from "vue-router";

const moveNextPrevented = ref(false);
let moveNextTimer: number | null = null;

type ResourceKeys = {
    titleKey: string,
    helpContent: string,
    structure: string,
    dimensionsTitle: string,
    length: string,
    height: string
}

const texts: { [key: string]: ResourceKeys} = {
    "backpanel": {
        titleKey: "backpanel",
        helpContent: "backpanelHelpContent",
        structure: "backpanelStructure",
        dimensionsTitle: "backpanelDimensionsTitle",
        length: "backpanelLength",
        height: "backpanelHeight"
    },
    "decorative-panel": {
        titleKey: "decorativePanel",
        helpContent: "decorativePanelHelpContent",
        structure: "decorativePanelStructure",
        dimensionsTitle: "decorativePanelDimensionsTitle",
        length: "backpanelLength",
        height: "backpanelHeight"
    }
}

const route = useRoute();
const { state } = useState();
const { ui } = useUI();
const resourceKeys: Ref<ResourceKeys> = ref(texts["backpanel"]);

function moveNext() {
    moveNextPrevented.value = true;

    moveNextTimer = setTimeout(() => moveNextPrevented.value = false, 3000);
}

function mounted() {
    state.mode = "backpanel";
    resourceKeys.value = texts[route.path.slice(4)];
}

mounted();
</script>
